module.exports = __webpack_public_path__ + "static/media/brisbane-lions-logo.31a0998a.svg";